import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import {
  CustomerZonePostcodeMoveRequestType,
  CustomerZonePostcodeMoveResponseType,
} from "@sellar-io/api-v2/types";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCustomerZonePostcodesMove = (targetZoneId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: async ({
      customerZoneId = targetZoneId,
      ...data
    }: CustomerZonePostcodeMoveRequestType & { customerZoneId?: number }) => {
      const response = await apiV2Request({
        user,
        business,
        method: "post",
        path: `customer-zones/${customerZoneId}/postcodes/move`,
        data,
      });
      return apiV2AssertResponse(response)
        .data as CustomerZonePostcodeMoveResponseType;
    },
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.CustomerZonePostcodes,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [business?.id, ServerStateKeys.CustomerZones],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.DeliveryArea],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Suppliers],
      });
    },
  });
};
